import React from 'react'

import { ErrorLayout } from './error-layout'

// A full reload, because a crash on the home page leaves the route unchanged
// and client-side navigation would not clear the error boundary.
const handleOnClickHome = () => {
  window.location.assign('/')
}

export const ErrorPage = () => (
  <ErrorLayout
    message={{
      text: 'We could not show this page. Please try again, or return to the home.',
      tx: 'error.crash.message.text'
    }}
    onHome={handleOnClickHome}
  />
)
